import { Component, OnInit, Renderer2 } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { TemporadaService } from '../../../catalogos/temporadas/services/temporada.service';
import { TemporadaViewModel } from '../../../catalogos/temporadas/models/temporada-view-model';

import { EquipoService } from '../../../catalogos/equipos/services/equipo.service';
import { EquipoViewModel } from '../../../catalogos/equipos/models/equipo-view-model';

import { CompeticionService } from '../../../catalogos/competiciones/services/competicion.service';
import { CompeticionViewModel } from '../../../catalogos/competiciones/models/competicion-view-model';

import { ClasificacionService } from '../../clasificaciones/services/clasificacion.service';
import { ClasificacionViewModel } from '../../clasificaciones/models/clasificacion-view-model';

import { PartidoService } from '../../partidos/services/partido.service';
import { PartidoViewModel } from '../../partidos/models/partido-view-model';

@Component({
    selector: 'app-competicion-list',
    templateUrl: './competicion-list.component.html',
    styleUrls: ['./competicion-list.component.scss']
})
export class CompeticionesListComponent implements OnInit {

    constructor(
        private temporadaService: TemporadaService,
        private equipoService: EquipoService,
        private competicionService: CompeticionService,
        private partidoService: PartidoService,
        private clasificacionService: ClasificacionService,
        private modalService: NgbModal,
        private renderer: Renderer2) { }

    ngOnInit(): void {
        this.loadTemporadas();
        let competicionesFavoritas = localStorage.getItem('competicionesFavoritas');
        if (competicionesFavoritas != null)  {
            this.localCompeticionesFavoritas = JSON.parse(competicionesFavoritas);
        }
        this.setImgFavoriteSource();
    }

    loading: boolean = false;

    temporadas: TemporadaViewModel[] = [];
    temporadaSel: TemporadaViewModel | null =  null;

    loadTemporadas() {
        this.loading = true;
        this.temporadaService.getTemporadas().subscribe(response => {
            this.temporadas = [];
            response.docs.forEach(value => {
                const data = value.data();
                const id = value.id;
                const temporada: TemporadaViewModel = {
                    id: id,
                    nombre: data.nombre,
                    descripcion: data.descripcion,
                    fechaInicio: data.fechaInicio,
                    fechaFin: data.fechaFin,
                    finalizada: data.finalizada,
                    codFmp: data.codFmp,
                    _fechaModificacion: data.fechaModificacion,
                    _userModificacion: data.userModificacion,
                    _lgBaja: data.lgBaja,
                    _fechaBaja: data.fechaBaja,
                    _userBaja: data.userBaja
                };

                this.temporadas.push(temporada);
            });
            
            if (this.temporadas.length > 0) {
                this.temporadaSel = this.temporadas[0];
                this.loadEquipos(this.temporadaSel.id);
            }

            this.loading = false;
        });
    }

    equipos: EquipoViewModel[] = [];

    loadEquipos(temporadaId: string) {
        this.loading = true;
        this.equipoService.getEquipos(temporadaId).subscribe(response => {
            this.equipos = [];
            response.docs.forEach(value => {
                const data = value.data();
                const id = value.id;
                const equipo: EquipoViewModel = {
                    id: id,
                    nombre: data.nombre,
                    descripcion: data.descripcion,
                    categoriaId: data.categoriaId,
                    codFmp: data.codFmp,
                    orden: data.orden,
                    _fechaModificacion: data.fechaModificacion,
                    _userModificacion: data.userModificacion,
                    _lgBaja: data.lgBaja,
                    _fechaBaja: data.fechaBaja,
                    _userBaja: data.userBaja,
                    temporadaId: temporadaId
                };

                this.equipos.push(equipo);
                this.loadCompeticiones(temporadaId, equipo.id);
            });

            this.loading = false;
        });
    }

    competiciones: CompeticionViewModel[] = [];
    competicionSel: CompeticionViewModel | null = null;

    loadCompeticiones(temporadaId: string, equipoId: string) {
        this.loading = true;
        this.competicionService.getCompeticiones(temporadaId, equipoId).subscribe(response => {
            //this.competiciones = [];
            response.docs.forEach(value => {
                const data = value.data();
                const id = value.id;
                const competicion: CompeticionViewModel = {
                    id: id,
                    nombre: data.nombre,
                    descripcion: data.descripcion,
                    orden: data.orden,
                    codFmp: data.codFmp,
                    _fechaModificacion: data.fechaModificacion,
                    _userModificacion: data.userModificacion,
                    _lgBaja: data.lgBaja,
                    _fechaBaja: data.fechaBaja,
                    _userBaja: data.userBaja,
                    temporadaId: temporadaId,
                    equipoId: equipoId
                };

                this.competiciones.push(competicion);
            });

            this.loading = false;
        });
    }

    clasificaciones: ClasificacionViewModel[] = [];

    loadClasificaciones(temporadaId: string, equipoId: string, competicionId: string) {
        console.log("Temporada: " + temporadaId);
        console.log("Equipo: " + equipoId);
        console.log("Competici�n: " + competicionId);

        this.loading = true;
        this.clasificacionService.getClasificaciones(temporadaId, equipoId, competicionId).subscribe(response => {
            this.clasificaciones = [];
            console.log("Clasificaciones: " + response.docs.length);
            response.docs.forEach(value => {
                const data = value.data();
                const id = value.id;
                const clasificacion: ClasificacionViewModel = {
                    id: id,
                    posicion: data.posicion,
                    equipo: data.equipo,
                    puntos: data.puntos,
                    partidosJugados: data.partidosJugados,
                    partidosGanados: data.partidosGanados,
                    partidosEmpatados: data.partidosEmpatados,
                    partidosPerdidos: data.partidosPerdidos,
                    golesAFavor: data.golesAFavor,
                    golesEnContra: data.golesEnContra,
                    golAverage: data.golAverage,
                    penaltis: data.penaltis,
                    temporadaId: temporadaId,
                    equipoId: equipoId,
                    competicionId: competicionId
                };

                this.clasificaciones.push(clasificacion);
            });

            this.loading = false;
        });
    }

    partidos: PartidoViewModel[] = [];

    loadPartidos(temporadaId: string, equipoId: string, competicionId: string) {
        console.log("Temporada: " + temporadaId);
        console.log("Equipo: " + equipoId);
        console.log("Competici�n: " + competicionId);
        this.partidoService.getPartidos(temporadaId, equipoId, competicionId).subscribe(response => {
            this.partidos = [];
            console.log("Partidos: " + response.docs.length);
            response.docs.forEach(value => {
                const data = value.data();
                const id = value.id;
                const partido: PartidoViewModel = {
                    id: id,
                    idPartido: data.idPartido,
                    descPartido: data.descPartido,
                    equipoLocal: data.equipoLocal,
                    equipoVisitante: data.equipoVisitante,
                    fecha: data.fecha,
                    hora: data.hora,
                    resultado: data.resultado,
                    pista: data.pista,
                    temporadaId: temporadaId,
                    equipoId: equipoId,
                    competicionId: competicionId,
                    competicionName: ""
                };

                this.partidos.push(partido);
            });
        });
    }

    selectCompeticionChangeHandler(event: any) {
        console.log("Cambio en competici�n: " + event.target.value)
        if (event.target.value != "") {
            let index = this.competiciones.findIndex(value => value.id == event.target.value);
            this.competicionSel = this.competiciones[index];

            this.loadPartidos(this.competicionSel.temporadaId, this.competicionSel.equipoId, this.competicionSel.id);
            this.loadClasificaciones(this.competicionSel.temporadaId, this.competicionSel.equipoId, this.competicionSel.id);
        } else {
            this.partidos = [];
            this.clasificaciones = [];
            this.competicionSel = null;
        }

        this.setImgFavoriteSource ();
    }

    opcion: number = 1

    selectOpcionChangeHandler(event: any) {
        const divPartidos = document.getElementById('divPartidos');
        const divClasificacion = document.getElementById('divClasificacion');
        if (event.target.value == "1") {
            if (divPartidos != null)
                divPartidos.style.display = "block";
            if (divClasificacion != null)
                divClasificacion.style.display = "none";
        } else {
            if (divPartidos != null)
                divPartidos.style.display = "block";
            if (divClasificacion != null)
                divClasificacion.style.display = "none";
        }
        this.opcion = event.target.value;
    }
    
    localCompeticionesFavoritas : CompeticionViewModel[] = [];
    
    selectFavoriteCompeticion() {
        if (this.competicionSel != null) {
            let index = -1;
            if (this.localCompeticionesFavoritas.length > 0){
                index = this.localCompeticionesFavoritas.findIndex(value => value.id == this.competicionSel!.id);
            }
            
            if (index > -1){
                this.localCompeticionesFavoritas.splice(index, 1);
            } else  {
                this.localCompeticionesFavoritas.push(this.competicionSel);
            }
    
            localStorage.setItem('competicionesFavoritas', JSON.stringify(this.localCompeticionesFavoritas));
            
            this.setImgFavoriteSource();
        }
    }
    
    setImgFavoriteSource (){
        const imgFavorite = document.getElementById('imgFavorite') as HTMLImageElement;
        if (this.competicionSel != null) {
            let index = -1;
            if (this.localCompeticionesFavoritas.length > 0){
                index = this.localCompeticionesFavoritas.findIndex(value => value.id == this.competicionSel!.id);
            }
            
            if (index > -1){
                imgFavorite.src = "/assets/imgs/ic_estrella_selected.png";
            } else  {
                imgFavorite.src = "/assets/imgs/ic_estrella_unselected.png";
            }
        } else {
                imgFavorite.src = "/assets/imgs/transparent.png";
        }
    }
}
